/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { DOCUMENT_HEAD_TITLE_SET } from 'state/action-types';
import { createReducer } from 'state/utils';

export const title = createReducer('Tower Advantage Link', {
    [DOCUMENT_HEAD_TITLE_SET]: (state, action) => action.title,
});

export default combineReducers({
    title,
});
